import { render, staticRenderFns } from "./Page-Compendio.vue?vue&type=template&id=2e9150ed&scoped=true"
import script from "./Page-Compendio.vue?vue&type=script&lang=js"
export * from "./Page-Compendio.vue?vue&type=script&lang=js"
import style0 from "./Page-Compendio.vue?vue&type=style&index=0&id=2e9150ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9150ed",
  null
  
)

export default component.exports